import { push } from 'redux-first-history';
import { getAlertMessageFunction } from '../../common/Util';
import { clearLogin } from '../../features/login/loginSlice';

// 중복 alert 방지 (1초 내 동일 메시지 무시)
let lastAlertMsg = '';
let lastAlertTime = 0;

const showAlert = (alertMessage, msg, type) => {
  const now = Date.now();
  if (msg === lastAlertMsg && now - lastAlertTime < 1000) {
    return false;
  }
  lastAlertMsg = msg;
  lastAlertTime = now;
  alertMessage(msg, type);
  return true;
};

const alertMiddleware = store => next => action => {
  if (action.type.endsWith('/fulfilled')) {
    const alertMessage = getAlertMessageFunction();
    const { sessionCode, resultCode, resultMsg = '', sessionMsg } = action.payload || {};

    //세션만료 등
    if (sessionCode === '-1' && sessionMsg) {
      if (showAlert(alertMessage, sessionMsg, 'error')) {
        store.dispatch(clearLogin());
      }
    }
    //잘못된 접근
    if (sessionCode === '-2' && sessionMsg) {
      if (showAlert(alertMessage, sessionMsg, 'error')) {
        store.dispatch(clearLogin());
      }
    }

    //비밀번호 변경 안한애들
    if (sessionCode === '-4') {
      if (location.pathname !== '/myInfo') {
        if (sessionMsg) {
          showAlert(alertMessage, sessionMsg, 'error');
        }
        store.dispatch(push('/myInfo'));
      }
    }

    //전직장 삭제.. 등등
    if (resultCode === 'ERR' && resultMsg) {
      showAlert(alertMessage, resultMsg);
    }

    if (resultCode == '0' && resultMsg) {
      showAlert(alertMessage, resultMsg);
    }
  }
  return next(action);
};

export default alertMiddleware;
